import type { ReactNode } from "react";
import styles from "./Button.module.css";

type ButtonVariant = "primary" | "accent" | "secondary" | "ghost" | "destructive";
type ButtonSize = "sm" | "md" | "lg";

interface ButtonBaseProps {
  readonly variant?: ButtonVariant;
  readonly size?: ButtonSize;
  readonly fullWidth?: boolean;
  readonly children: ReactNode;
  readonly className?: string;
}

interface ButtonAsButton extends ButtonBaseProps {
  readonly href?: undefined;
  readonly type?: "button" | "submit";
  readonly onClick?: () => void;
  readonly disabled?: boolean;
}

interface ButtonAsLink extends ButtonBaseProps {
  readonly href: string;
  readonly type?: undefined;
  readonly onClick?: undefined;
  readonly disabled?: undefined;
}

type ButtonProps = ButtonAsButton | ButtonAsLink;

export function Button({
  variant = "primary",
  size = "md",
  fullWidth,
  children,
  className,
  href,
  ...rest
}: ButtonProps) {
  const classes = `${styles.button} ${styles[variant]} ${styles[size]} ${fullWidth ? styles.fullWidth : ""} ${className ?? ""}`;

  if (href) {
    return (
      <a href={href} className={classes}>
        {children}
      </a>
    );
  }

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
}
